import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href: string;
  text: string;
  className?: string;
}
export function CTAButton({
  href,
  text,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} className={`block w-full max-w-md mx-auto bg-[#D4A853] hover:bg-[#B8935C] text-[#1B4332] font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-sm text-center cursor-pointer transition-colors ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-402">
      {text}
    </motion.a>;
}